import axios from 'src/utils/axios';

export const getArtemisTaskHistory = ({ FisNo }) => axios.get(`/GetSiriusWorkOrderHistory/${FisNo}`);
